/// <reference path="../../types.d.ts" />
import { connect } from 'react-redux';
import CMx from './CMx';
import history from '../../history';
import { jumpContext } from '../../actions/contexts.action';
import { navigate, dismissFeedback, fetchContexts, changeAdminTab } from '../../actions/ui';
import { buildDispatchable } from '../../actions/_action-utilities';
import { logoutApp } from '../../actions/login.action';
import { authenticationChannel } from '@codametrix/ui-common';
import { navigateServiceLine } from '../../actions/service-lines';
import { toggleIsOpen } from '../../actions/account-settings';
import { toggleIsOpenCapturedTime, listCapturedTimeForWeek, listProtectedTimeForWeek, updateProtectedTimeEntry, addProtectedTimeEntry, deleteProtectedTimeEntry, getMaxAllowedBackdate } from '../../actions/captured-time';
import { listStatus, updateStatus, toggleIsOpenMyStatus } from '../../actions/my-status';
import { getSubNavPaths } from '../../actions/analytics';
const mapStateToProps = function(state) {
    const { ui, analytics } = state;
    const pathname = history.location.pathname;
    return {
        ...state.cmx,
        ...ui,
        ...state.myStatus,
        caseLoadState: state.cases.loadState,
        activeUser: state.ui.activeUser,
        eula: state.eula,
        accountSettingsIsOpen: state.accountSettings.isOpen,
        myStatusIsOpen: state.myStatus.myStatusIsOpen,
        capturedTimeIsOpen: state.capturedTime.capturedTimeIsOpen,
        showSideNavBar: state.codeBench.showSideNavBar,
        showDashboardOptions: analytics.showDashboardOptions,
        hasWorklistMaintenanceWindow: state.ui.hasWorklistMaintenanceWindow,
        pathname
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        onLoad: (navData)=>{
            runDispatchable(async ()=>{
                let url = new URL(window.location.href);
                let params = new URLSearchParams(url.search);
                if (params.has('channel')) {
                    await authenticationChannel.ready;
                }
                return dispatch(fetchContexts(navData));
            });
        },
        handleOrganizationChoice: (choice)=>{
            runDispatchable(()=>{
                const promise = dispatch(jumpContext({
                    organizationId: `${choice.organizationId}`,
                    servicelineId: choice.servicelineId
                }));
                // jump to a meaningless url, this will make sure that componentWillMount will
                // run when again.
                history.push('/cmx/jump');
                return promise;
            });
        },
        handleServiceLineChoice: (choice, context, actionGroups)=>{
            runDispatchable(()=>{
                return dispatch(navigateServiceLine({
                    choice,
                    context,
                    actionGroups
                }));
            });
        },
        onSelection: (selection)=>{
            let subNav;
            if (selection.subActions) {
                subNav = selection.subActions.find((subAction)=>{
                    return subAction.active === true;
                });
            }
            dispatch(navigate(subNav ? subNav : selection));
            history.push(subNav ? `/cmx/${subNav.path}` : `/cmx/${selection.path}`);
        },
        dismissFeedback: (message)=>dispatch(dismissFeedback(true)),
        logout: (orgCode)=>{
            dispatch(logoutApp({
                showModal: true,
                orgCode
            }));
        },
        navigateEula: ()=>{
            history.push('/eula/');
        },
        selectAdminTab: (navPath, activeSubAction, adminTabs)=>{
            runDispatchable(()=>{
                history.push('/cmx/' + navPath);
                dispatch(navigate(activeSubAction));
                return dispatch(changeAdminTab(adminTabs));
            });
        },
        openAccountSettings: ()=>{
            runDispatchable(()=>{
                history.push('#AccountSettings');
                return dispatch(toggleIsOpen(true));
            });
        },
        openMyStatus: ()=>{
            runDispatchable(()=>{
                history.push('#MyStatus');
                return dispatch(toggleIsOpenMyStatus(true));
            });
        },
        openCapturedTime: ()=>{
            runDispatchable(()=>{
                history.push('#CapturedTime');
                return dispatch(toggleIsOpenCapturedTime(true));
            });
        },
        listStatus: (activeTenantId)=>{
            runDispatchable(()=>{
                return dispatch(listStatus({
                    activeTenantId
                }));
            });
        },
        updateStatus: (status, user, context)=>{
            runDispatchable(()=>{
                return dispatch(updateStatus({
                    status,
                    user,
                    context
                }));
            });
        },
        listCapturedTime: (startDate, endDate, user, context)=>{
            runDispatchable(()=>{
                return dispatch(listCapturedTimeForWeek({
                    startDate,
                    endDate,
                    user,
                    context
                }));
            });
        },
        listProtectedTime: (startDate, endDate, user, context)=>{
            runDispatchable(()=>{
                return dispatch(listProtectedTimeForWeek({
                    startDate,
                    endDate,
                    user,
                    context
                }));
            });
        },
        deleteProtectedTimeEntry: (workLogId)=>{
            runDispatchable(()=>{
                return dispatch(deleteProtectedTimeEntry({
                    workLogId
                }));
            });
        },
        updateProtectedTimeEntry: (workLogId, workLog)=>{
            runDispatchable(()=>{
                return dispatch(updateProtectedTimeEntry({
                    workLogId,
                    workLog
                }));
            });
        },
        addProtectedTimeEntry: (workLogProtectedRequestDto)=>{
            runDispatchable(()=>{
                return dispatch(addProtectedTimeEntry({
                    workLogProtectedRequestDto
                }));
            });
        },
        getMaxAllowedBackdate: (key, tenantId)=>{
            runDispatchable(()=>{
                return dispatch(getMaxAllowedBackdate({
                    key,
                    tenantId
                }));
            });
        },
        getSubNavPaths: (userDetails)=>{
            runDispatchable(()=>{
                return dispatch(getSubNavPaths(userDetails));
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(CMx);
